/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Speaker_Id_TitleInputs */

const en_automatic_speaker_id_title = /** @type {(inputs: Automatic_Speaker_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatic Speaker ID`)
};

const fr_automatic_speaker_id_title = /** @type {(inputs: Automatic_Speaker_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identification auto des intervenants`)
};

const de_automatic_speaker_id_title = /** @type {(inputs: Automatic_Speaker_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Sprecheridentifizierung`)
};

const it_automatic_speaker_id_title = /** @type {(inputs: Automatic_Speaker_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificazione automatica dell'altoparlante`)
};

const ru_automatic_speaker_id_title = /** @type {(inputs: Automatic_Speaker_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическая идентификация говорящего`)
};

const es_automatic_speaker_id_title = /** @type {(inputs: Automatic_Speaker_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificación automática del orador`)
};

const zh_cn2_automatic_speaker_id_title = /** @type {(inputs: Automatic_Speaker_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动说话人识别`)
};

const ja_automatic_speaker_id_title = /** @type {(inputs: Automatic_Speaker_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動スピーカーID`)
};

const hi_automatic_speaker_id_title = /** @type {(inputs: Automatic_Speaker_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित स्पीकर आईडी`)
};

const pt_pt2_automatic_speaker_id_title = /** @type {(inputs: Automatic_Speaker_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Identificação automática de locutor`)
};

/**
* | output |
* | --- |
* | "Automatic Speaker ID" |
*
* @param {Automatic_Speaker_Id_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_speaker_id_title = /** @type {((inputs?: Automatic_Speaker_Id_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Speaker_Id_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_automatic_speaker_id_title(inputs)
	if (locale === "de") return de_automatic_speaker_id_title(inputs)
	if (locale === "it") return it_automatic_speaker_id_title(inputs)
	if (locale === "ru") return ru_automatic_speaker_id_title(inputs)
	if (locale === "es") return es_automatic_speaker_id_title(inputs)
	if (locale === "zh-CN") return zh_cn2_automatic_speaker_id_title(inputs)
	if (locale === "ja") return ja_automatic_speaker_id_title(inputs)
	if (locale === "hi") return hi_automatic_speaker_id_title(inputs)
	if (locale === "pt-PT") return pt_pt2_automatic_speaker_id_title(inputs)
	return en_automatic_speaker_id_title(inputs)
});